import * as angular from 'angular';
import * as $ from 'jquery';

export const DocBlur = function ($window, $timeout) {
  return {
    restrict: 'A',

    link: function ($scope: any, $elem) {
      let hasFocus = false;
      const onBlur = function (ev) {
        if ($scope.onDocBlur && hasFocus && !$(ev.target).closest($elem).length) {
          $($window.document).off('mousedown.' + $scope.docBlur, onBlur);
          $scope.$evalAsync(function () {
            $scope.onDocBlur({ $event: ev });
          });
        }
      };

      $scope.$watch('docBlurHasFocus', function (focus) {
        hasFocus = focus;
        if (focus) {
          // update asynchronously to prevent element from immediately closing in dropdown or similar use case
          // where the element that triggers showing the augmented DOM is not inside it.
          $timeout(
            function () {
              $($window.document).on('mousedown.' + $scope.docBlur, onBlur);
            },
            0,
            false
          );
        }
      });

      $scope.$on('$destroy', function () {
        $($window.document).off('mousedown.' + $scope.docBlur, onBlur);
      });
    },

    scope: {
      onDocBlur: '&',
      docBlurHasFocus: '<',
      docBlur: '<',
    },
  };
};

DocBlur.$inject = ['$window', '$timeout'];
